import { jsx } from "react/jsx-runtime";
import { Button, styled } from "@mui/material";
import { sectionName } from "../classes.js";
const StyledLoadMore = styled(Button)(({ theme }) => ({
  fontSize: "13px",
  lineHeight: "22px",
  alignSelf: "center",
  textTransform: "none",
  marginTop: theme.spacing(2.5),
  marginBottom: theme.spacing(0.5)
}));
function LoadMoreBase(props) {
  const { contentCount, expanded, hasMoreContent, maxPinned, pageSize, pinnedCount, topCount, ...rest } = props;
  return hasMoreContent ? /* @__PURE__ */ jsx(StyledLoadMore, { ...rest }) : null;
}
const LoadMore = styled(LoadMoreBase, {
  name: sectionName,
  slot: "LoadMore",
  overridesResolver: (_props, styles) => [styles.loadMore]
})``;
export {
  LoadMore
};
//# sourceMappingURL=LoadMore.js.map
